module.exports = __webpack_public_path__ + "static/img/baoming_y.97302446.png";